import React from 'react';
import { Badge, BadgeProps } from 'pounceV2';

interface BetaTagProps extends Omit<BadgeProps, 'children' | 'variant'> {
  variant?: 'fill' | 'border';
  size?: BadgeProps['size'];
}

/**
 * Displays that a feature is currently "BETA" (not fully stable). Comes in two
 * variants, filled (solid background) and border (transparent background)
 */
export const BetaTagV3 = ({ variant = 'fill', size = 'medium', ...props }: BetaTagProps) => {
  return (
    <Badge
      variant={variant === 'fill' ? 'neutral-subtle' : 'neutral-outline'}
      size={size}
      borderStyle="rectangle"
      {...props}
    >
      BETA
    </Badge>
  );
};

export default BetaTagV3;
